<template>
  <div class="mediation-committee-container animated fadeInRight">
    <el-card>
      <div slot="header" class="flex justify-between">
        <span>调委会管理</span>
        <el-button type="primary" size="small" @click="_openAdd">新增调委会</el-button>
      </div>
      <el-row :gutter="20" style="margin-bottom:15px">
        <el-col :span="6">
          <el-input v-model="conditions.name" placeholder="按名称搜索" clearable @keyup.enter.native="_loadList" />
        </el-col>
        <el-col :span="4">
          <el-button type="primary" @click="_loadList">查询</el-button>
          <el-button @click="_resetConditions">重置</el-button>
        </el-col>
      </el-row>
      <el-table :data="tableData" border v-loading="loading" style="width:100%">
        <el-table-column prop="name" label="调委会名称" align="center" />
        <el-table-column prop="phone" label="联系电话" align="center" width="160" />
        <el-table-column prop="address" label="地址" align="center" show-overflow-tooltip />
        <el-table-column prop="createTime" label="创建时间" align="center" width="180" />
        <el-table-column label="操作" align="center" width="180">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="_openEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="_doDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 新增/编辑 弹窗 -->
    <el-dialog :title="editDialog.isEdit ? '编辑调委会' : '新增调委会'" :visible.sync="editDialog.visible" width="600px" :close-on-click-modal="false">
      <el-form :model="editDialog" label-width="100px">
        <el-form-item label="调委会名称" required>
          <el-input v-model="editDialog.name" placeholder="请填写调委会名称" maxlength="100" show-word-limit />
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="editDialog.phone" placeholder="请填写联系电话" maxlength="20" />
        </el-form-item>
        <el-form-item label="地址">
          <el-input type="textarea" v-model="editDialog.address" :rows="3" placeholder="请填写地址" maxlength="256" show-word-limit />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="editDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="_submitEdit" :loading="editDialog.submitting">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  listCommittees,
  saveCommittee,
  updateCommittee,
  deleteCommittee
} from '@/api/oa/mediationApi'

export default {
  name: 'MediationCommitteeList',
  data() {
    return {
      loading: false,
      tableData: [],
      conditions: {
        name: ''
      },
      editDialog: {
        visible: false,
        isEdit: false,
        committeeId: '',
        name: '',
        phone: '',
        address: '',
        submitting: false
      }
    }
  },
  mounted() {
    this._loadList()
  },
  methods: {
    _loadList() {
      this.loading = true
      listCommittees(this.conditions).then(res => {
        const d = res.data || res || {}
        this.tableData = d.committees || []
      }).catch(err => {
        this.$message.error(err || '加载失败')
        this.tableData = []
      }).finally(() => {
        this.loading = false
      })
    },
    _resetConditions() {
      this.conditions.name = ''
      this._loadList()
    },
    _openAdd() {
      this.editDialog.isEdit = false
      this.editDialog.committeeId = ''
      this.editDialog.name = ''
      this.editDialog.phone = ''
      this.editDialog.address = ''
      this.editDialog.visible = true
    },
    _openEdit(row) {
      this.editDialog.isEdit = true
      this.editDialog.committeeId = row.committeeId
      this.editDialog.name = row.name
      this.editDialog.phone = row.phone
      this.editDialog.address = row.address
      this.editDialog.visible = true
    },
    _submitEdit() {
      if (!this.editDialog.name) {
        this.$message.error('请填写调委会名称')
        return
      }
      this.editDialog.submitting = true
      const fn = this.editDialog.isEdit ? updateCommittee : saveCommittee
      const params = {
        committeeId: this.editDialog.committeeId,
        name: this.editDialog.name,
        phone: this.editDialog.phone,
        address: this.editDialog.address
      }
      fn(params).then(() => {
        this.$message.success(this.editDialog.isEdit ? '更新成功' : '保存成功')
        this.editDialog.visible = false
        this._loadList()
      }).catch(err => {
        this.$message.error(err || '操作失败')
      }).finally(() => {
        this.editDialog.submitting = false
      })
    },
    _doDelete(row) {
      this.$confirm('确认删除该调委会？已关联案件的调委会信息保留。', '删除确认', {
        type: 'warning'
      }).then(() => {
        deleteCommittee({ committeeId: row.committeeId }).then(() => {
          this.$message.success('删除成功')
          this._loadList()
        }).catch(err => {
          this.$message.error(err || '删除失败')
        })
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.mediation-committee-container {
  padding: 20px;
}
.flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
